import { camCenteringOn, type Cam } from '../useCamera.js';

/** One-shot zoom + center on a character; follow keeps scale, recenters each frame. */
export function cameraFollowCharacter(args: {
  cam: Cam;
  stageW: number;
  stageH: number;
  worldX: number;
  worldY: number;
  canvasW: number;
  canvasH: number;
  minScale: number;
}): Cam {
  const { cam, stageW, stageH, worldX, worldY, canvasW, canvasH, minScale } = args;
  const scale = Math.min(3, Math.max(minScale, 2));
  return camCenteringOn(
    { scale, ox: cam.ox, oy: cam.oy },
    stageW,
    stageH,
    worldX,
    worldY,
    canvasW,
    canvasH,
    0,
    0,
  );
}
